import React from 'react';
import { Inbox } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/**
 * Replaces bare "No data" text everywhere. `icon` defaults to a generic
 * inbox glyph; pass a lucide icon relevant to the context (Users, Package,
 * Key, etc.) for a more specific illustration.
 */
const EmptyState = ({
  icon: Icon = Inbox,
  title = 'Nothing here yet',
  description,
  actionLabel,
  onAction,
  helpHref,
  helpLabel = 'Learn more',
  compact = false,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        compact ? 'gap-2 py-4' : 'gap-3 py-12',
        className
      )}
    >
      <div
        className={cn(
          'flex items-center justify-center rounded-2xl bg-gradient-to-br from-muted to-muted/50 ring-1 ring-border',
          compact ? 'h-10 w-10' : 'h-14 w-14'
        )}
      >
        <Icon className={cn('text-muted-foreground', compact ? 'h-5 w-5' : 'h-6 w-6')} />
      </div>
      <div className="space-y-1">
        <p className={cn('font-medium text-foreground', compact ? 'text-sm' : 'text-base')}>{title}</p>
        {description && (
          <p className={cn('mx-auto max-w-xs text-muted-foreground', compact ? 'text-xs' : 'text-sm')}>
            {description}
          </p>
        )}
      </div>
      {(actionLabel || helpHref) && (
        <div className="mt-1 flex items-center gap-3">
          {actionLabel && (
            <Button size={compact ? 'sm' : 'default'} onClick={onAction} className="bg-primary hover:bg-primary/90">
              {actionLabel}
            </Button>
          )}
          {helpHref && (
            <a
              href={helpHref}
              target="_blank"
              rel="noreferrer"
              className="text-xs font-medium text-primary hover:underline"
            >
              {helpLabel}
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default EmptyState;
